import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import * as moment from 'moment';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';
import CountrySelectComponent from 'src/modules/commons/inputs/country-select/CountrySelect.component';
import Datepicker from 'src/modules/commons/datepicker/Datepicker.component';

interface JuridicalInformationFormComponentProps {
  formData: JuridicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean | moment.Moment) => void;
}

class JuridicalInformationFormComponent extends React.Component<JuridicalInformationFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question44"
        >
          <div className="icon-title">
            <img
              alt="Euro"
              className="icon"
              src="/img/us.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Información personal
              </strong>
              <span className="d-arrow-up" />
            </h4>
            <div className="gap-20" />
          </div>
        </div>
        <div
          id="question44"
          className="collapse"
        >
          <p>
            <strong>
              Los datos que introduzcas deberán ser los mismos que aparecen en tu NIF o NIE:
            </strong>
          </p>
          <p className="question-detail">
            Recuerda, los campos marcados con * son obligatorios
          </p>
          <div className="gap-20" />
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Nombre"
                  type="text"
                  value={this.props.formData.name}
                  onChange={(value) => this.props.handleChange('name')(value)}
                  required={true}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Apellido/s"
                  type="text"
                  value={this.props.formData.surname}
                  onChange={(value) => this.props.handleChange('surname')(value)}
                  required={true}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <CountrySelectComponent
                value={this.props.formData.nationality}
                required={true}
                label={'Nacionalidad'}
                onChange={this.props.handleChange('nationality')}
              />
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="gap-20" />
              <div className="md-input">
                <InputContainer
                  label="NIF o NIE"
                  type="text"
                  value={this.props.formData.idNumber || ''}
                  onChange={(value) => this.props.handleChange('idNumber')(value)}
                  required={true}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4 date-group">
              <Datepicker
                label="Fecha de caducidad del documento"
                required={true}
                value={this.props.formData.idExpirationDate}
                handleChange={this.props.handleChange('idExpirationDate')}
              />
            </div>
            <div className="col-sm-6 col-md-4 date-group">
              <Datepicker
                label="Fecha de nacimiento"
                required={true}
                value={this.props.formData.birthDate}
                handleChange={this.props.handleChange('birthDate')}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Teléfono móvil"
                  type="text"
                  required={true}
                  value={
                    this.props.formData.phoneNumber ?
                      this.props.formData.phoneNumber :
                      ''
                  }
                  onChange={(value) => this.props.handleChange('phoneNumber')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div
                className="md-input"
                data-container="body"
                data-html="true"
                data-trigger="hover"
                data-toggle="popover"
                data-placement="bottom"
                data-content={this.getTooltip()}
              >
                <InputContainer
                  label="Email de notificationes"
                  type="text"
                  required={true}
                  value={
                    this.props.formData.notificationEmail ?
                      this.props.formData.notificationEmail :
                      ''
                  }
                  onChange={(value) => this.props.handleChange('notificationEmail')(value)}
                />
              </div>
              <div className="gap-20" />
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="grey-box c-grey">
                <p>
                  <strong>
                    Email de usuario:
                  </strong>
                  <br />
                  {this.props.formData.email}
                </p>
              </div>
              <div className="gap-20" />
            </div>
          </div>
          <div className="gap-20" />
        </div>
      </section>
    );
  }
  private getTooltip(): string {
    return `
      <p>En este mail recibirás todo lo referente a tus inversiones</p>
    `;
  }
}

export default JuridicalInformationFormComponent;



// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/forms/JuridicalInformationForm.tsx